import { render, staticRenderFns } from "./LanderIcon.vue?vue&type=template&id=172925b0"
import script from "./LanderIcon.vue?vue&type=script&lang=js"
export * from "./LanderIcon.vue?vue&type=script&lang=js"
import style0 from "./LanderIcon.vue?vue&type=style&index=0&id=172925b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports